module.exports = __webpack_public_path__ + "img/illustration-no-access.1bd7228f.svg";